export default __webpack_public_path__ + "static/media/commercial-video-usage-range.06c9d8bc.svg";